/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BillStatusEnum as DigiworkMaitreDDomenModelBillStatusEnum } from '../../models/Digiwork/MaitreD/Domen/Model/bill-status-enum';
import { BillsDto as DigiworkMaitreDPosDtoBillsBillsDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Bills/bills-dto';

export interface GetBillsForTable$Params {
  VenueId?: string;
  TableId?: string;
  Statuses?: Array<DigiworkMaitreDDomenModelBillStatusEnum>;
  WaiterId?: string;
  Date?: string;
}

export function getBillsForTable(http: HttpClient, rootUrl: string, params?: GetBillsForTable$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoBillsBillsDto>> {
  const rb = new RequestBuilder(rootUrl, getBillsForTable.PATH, 'get');
  if (params) {
    rb.query('VenueId', params.VenueId, {});
    rb.query('TableId', params.TableId, {});
    rb.query('Statuses', params.Statuses, {});
    rb.query('WaiterId', params.WaiterId, {});
    rb.query('Date', params.Date, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoBillsBillsDto>;
    })
  );
}

getBillsForTable.PATH = '/api/orders/bills';
